import { render, staticRenderFns } from "./AccountsReceivables.vue?vue&type=template&id=7b5d82f4&scoped=true&"
import script from "./AccountsReceivables.vue?vue&type=script&lang=js&"
export * from "./AccountsReceivables.vue?vue&type=script&lang=js&"
import style0 from "./AccountsReceivables.vue?vue&type=style&index=0&id=7b5d82f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5d82f4",
  null
  
)

export default component.exports